import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import { useFilterLayoutStyles } from '../utils/languageUtils';

interface DatePickerFilterProps {
    label: string;
    value?: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    placeholder?: string;
    required?: boolean;
    forceHorizontal?: boolean;
    format?: string;
    disabledDate?: (current: Dayjs) => boolean;
    allowClear?: boolean;
    showTime?: object | boolean;
}

/**
 * 日期选择器过滤项
 * @description 结合标签和DatePicker的公共组件，支持水平和竖直布局
 */
const DatePickerFilter: React.FC<DatePickerFilterProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    disabled = false,
    placeholder,
    required = false,
    forceHorizontal,
    format = 'YYYY-MM-DD',
    disabledDate,
    allowClear = true,
    showTime,
}) => {
    const { containerClassName, labelClassName, inputContainerClassName } = useFilterLayoutStyles(spanClassName, className, forceHorizontal);

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </span>
            <div className={inputContainerClassName}>
                <DatePicker
                    value={value}
                    onChange={onChange}
                    format={format}
                    placeholder={placeholder}
                    size="middle"
                    className="w-full"
                    allowClear={allowClear}
                    disabledDate={disabledDate}
                    disabled={disabled}
                    showTime={showTime}
                />
            </div>
        </div>
    );
};

export default DatePickerFilter;
